import { colors } from "./colors_v2.js";
import { identityService } from "./profile/identityService_v2.js";
import { utilsApp } from "./utils-app_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { iPop } from "./ipop_v2.js";
import { dasModal } from "./modal_v2.js";

const preferencesState = {
  visible: false,
};

const isVisible = () => {
  return preferencesState.visible;
};

const renderGear = () => {
  const html = `<div id="gear"></div>`;
  const settings = document.getElementById("settingsSection");
  settings.innerHTML = html;
};

const handleGearClick = () => {
  render();
};

const render = async () => {
  utilsApp.makeNavsSmall();
  preferencesState.visible = true;
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "block";
  modalBehinder.dataset.action = "modalBehinderClosePrefs";
  const settings = document.getElementById("settingsPop");
  const html = `
    <h3>Preferences</h3>
    <div id="optionsWrapper">
      <div id="animationWrapper"><div class="optionsSubHeader">Animation Mode</div>
        <div id="animationOptions">
            <div class="animation" id="serial">Sequential</div>
            <div class="animation" id="parallel">Parallel</div>
            <div class="animation" id="offAnim">Off</div>
        </div>
      </div>
      <div id="optionsLowerPart">
        
        <div id="colorOptions"><div class="optionsSubHeader">Colors</div>
          <div id="colorBarContainer">
            <div class="colorOption" id="muted"> Light: 
              <div class="colorGroup">
                <div class="colorBar" id="mutedPlayer1color"></div>
                <div class="colorBar" id="mutedPlayer2color"></div>
                <div class="colorBar" id="mutedBkgndColor"></div>
              </div>
            </div>

            <div class="colorOption" id="dark"> Dark: 
              <div class="colorGroup">
                <div class="colorBar" id="darkPlayer1color"></div>
                <div class="colorBar" id="darkPlayer2color"></div>
                <div class="colorBar" id="darkBkgndColor"></div>
              </div>
            </div>

            <div class="colorOption" id="desert"> Desert:
              <div class="colorGroup"> 
                <div class="colorBar" id="desertPlayer1color"></div>
                <div class="colorBar" id="desertPlayer2color"></div>
                <div class="colorBar" id="desertBkgndColor"></div>
              </div>
            </div>

            <div class="colorOption" id="jenn"> Jenn: 
              <div class="colorGroup">
                <div class="colorBar" id="jennPlayer1color"></div>
                <div class="colorBar" id="jennPlayer2color"></div>
                <div class="colorBar" id="jennBkgndColor"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class = "x" id="closeSettingsPop"></div>
    `;
  settings.style.display = "flex";
  settings.innerHTML = html;
  settings.style.background = colors.getGameColor("lighterAccent");
  settings.classList.add("shadow");
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    preferences.close();
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;

  if (pAIdentity.type === "account") {
    renderEmailOptions();
    await setEmailListeners();
    await setPopOptions();
  }

  setAnimListeners();
  setColorBarBkgnds();
  selectColorOption(colors.getScheme());
  setOptionsBackground();
};

const renderEmailOptions = () => {
  const html = `
      <div class="flexColumn">
        <div id="emailOptionsContainer" class="optionsContainer">
          <div class="optionsSubHeader">Email</div>
            <div class="emailOption" id="account">Profile:
              <div class="animation" id="accountOn">On</div>
              <div class="animation" id="accountOff">Off</div>
            </div>
            <div class="emailOption" id="match">Matches:
              <div class="animation" id="matchOn">On</div>
              <div class="animation" id="matchOff">Off</div>
            </div>
            <div class="emailOption" id="marketing">Marketing:<div id="marketingSplainer" class="i">ⓘ</div>
              <div class="animation" id="marketingOn">On</div>
              <div class="animation" id="marketingOff">Off</div>
            </div>
          </div id="endEmailNotifications">
          <div id="popUpsContainer" class="optionsContainer">
            <div class="optionsSubHeader">Pop ups</div>
            <div class="emailOption" id="postLogIn">After Log In:
              <div class="animation" id="postLogInOn">On</div>
              <div class="animation" id="postLogInOff">Off</div>
            </div>
            <div class="emailOption" id="createdPop">New Match:<div id="createdPopSplainer" class="i">ⓘ</div>
              <div class="animation" id="createdPopOn">On</div>
              <div class="animation" id="createdPopOff">Off</div>
            </div>
            <div class="emailOption" id="joinedPlayer">New Player:<div id="joinedSplainer" class="i">ⓘ</div>
              <div class="animation" id="joinedPlayerOn">On</div>
              <div class="animation" id="joinedPlayerOff">Off</div>
            </div>
            <div class="emailOption" id="changedPop">Match Update:<div id="changedPopSplainer" class="i">ⓘ</div>
              <div class="animation" id="changedPopOn">On</div>
              <div class="animation" id="changedPopOff">Off</div>
            </div>
            <div class="emailOption" id="joinedWatcher">New Watcher:<div id="newWatcherSplainer" class="i">ⓘ</div>
              <div class="animation" id="joinedWatcherOn">On</div>
              <div class="animation" id="joinedWatcherOff">Off</div>
            </div>
          </div id="endPopUpsContainer">
        </div id="endoptionsContainer>
      </div id="endFlexColumn">`;
  const optionsLowerPart = document.getElementById("optionsLowerPart");
  optionsLowerPart.innerHTML = html + optionsLowerPart.innerHTML;
};

const renderMarketingSplainer = (event) => {
  iPop.render({
    text: "We will never sell your email or other personal information. If this is set to 'On', it just means topagon.com might send an occasional email promoting something about this game, or perhaps one of our other endeavors. It won't happen often.",
    event,
  });
};

const renderNewWatcherSplainer = (event) => {
  iPop.render({
    text: "A new person has started watching a match, but you are not looking at that match.",
    event,
  });
};

const renderChangedPopSplainer = (event) => {
  iPop.render({
    text: "Your opponent played or the state changed, but you are not looking at that match.",
    event,
  });
};

const renderJoinedSplainer = (event) => {
  iPop.render({
    text: "Your opponent has joined your match, but you are not looking at that match.",
    event,
  });
};

const renderCreatedPopSplainer = (event) => {
  iPop.render({
    text: "You have been added to a new match.",
    event,
  });
};

const setOptionsBackground = () => {
  if (document.body.contains(document.getElementById("emailOptions"))) {
    document.getElementById("emailOptions").style.background =
      colors.getGameColor("tip");
  }

  document.getElementById("animationWrapper").style.background =
    colors.getGameColor("tip");
  document.getElementById("colorOptions").style.background =
    colors.getGameColor("tip");
  const emailOptionsContainer = document.getElementById(
    "emailOptionsContainer",
  );
  if (document.body.contains(emailOptionsContainer)) {
    emailOptionsContainer.style.background = colors.getGameColor("tip");
  }
  const popUpsContainer = document.getElementById("popUpsContainer");
  if (document.body.contains(popUpsContainer)) {
    popUpsContainer.style.background = colors.getGameColor("tip");
  }
};

const handlecloseClick = (event) => {
  close();
};

const close = () => {
  preferencesState.visible = false;

  const settingsPop = document.getElementById("settingsPop");
  settingsPop.style.display = "none";

  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
};

////////////////////////////////
// Email Settings Functions:
const setEmailListeners = async () => {
  const emailPrefs = await identityService.getEmailPrefs();
  if (Object.keys(emailPrefs).length > 0) {
    updateEmailSelections(emailPrefs);
  }
};

const handleMouseLeaveEmail = async () => {
  const emailPrefs = await identityService.getEmailPrefs();
  updateEmailSelections(emailPrefs);
};

const handleMouseEnterEmail = async (event, element) => {
  const gotClicked = element.id;
  const gotClickedElement = document.getElementById(gotClicked);
  const emailPrefs = await identityService.getEmailPrefs();
  if (gotClicked === "accountOn" && emailPrefs.account === true) {
    return;
  }
  if (gotClicked === "accountOff" && emailPrefs.account === false) {
    return;
  }
  if (gotClicked === "matchOn" && emailPrefs.match === true) {
    return;
  }
  if (gotClicked === "matchOff" && emailPrefs.match === false) {
    return;
  }
  if (gotClicked === "marketingOn" && emailPrefs.marketing === true) {
    return;
  }
  if (gotClicked === "marketingOff" && emailPrefs.marketing === false) {
    return;
  }
  gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
};

const handleEmailChange = async (event, element) => {
  const gotClicked = element.id;
  const emailPrefs = JSON.parse(
    JSON.stringify(await identityService.getEmailPrefs()),
  );
  switch (gotClicked) {
    case "accountOn":
      emailPrefs.account = true;
      break;
    case "accountOff":
      emailPrefs.account = false;
      break;
    case "matchOn":
      emailPrefs.match = true;
      break;
    case "matchOff":
      emailPrefs.match = false;
      break;
    case "marketingOn":
      emailPrefs.marketing = true;
      break;
    case "marketingOff":
      emailPrefs.marketing = false;
      break;
  }

  document.body.style.cursor = "wait";
  dasModal.render("<div class=max>Submitting...</div>");
  const result = await identityService.setEmailPrefs(emailPrefs);
  setTimeout(() => {
    dasModal.close();
  }, 500);

  document.body.style.cursor = "default";
  if (result.status === 200) {
    updateEmailSelections(emailPrefs);
  } else {
    console.log("ERROR: Unable to update email prefs mode");
  }
};

const updateEmailSelections = (emailPrefs) => {
  if (emailPrefs.account === true) {
    document.getElementById("accountOn").style.background =
      colors.getGameColor("accent");
    document.getElementById("accountOff").style.background = "none";
  } else {
    document.getElementById("accountOn").style.background = "none";
    document.getElementById("accountOff").style.background =
      colors.getGameColor("accent");
  }

  if (emailPrefs.match === true) {
    document.getElementById("matchOn").style.background =
      colors.getGameColor("accent");
    document.getElementById("matchOff").style.background = "none";
  } else {
    document.getElementById("matchOn").style.background = "none";
    document.getElementById("matchOff").style.background =
      colors.getGameColor("accent");
  }

  if (emailPrefs.marketing === true) {
    document.getElementById("marketingOn").style.background =
      colors.getGameColor("accent");
    document.getElementById("marketingOff").style.background = "none";
  } else {
    document.getElementById("marketingOn").style.background = "none";
    document.getElementById("marketingOff").style.background =
      colors.getGameColor("accent");
  }
};

////////////////////////////////
// Animation Settings Functions:
const setAnimListeners = async () => {
  selectOneAnim(await identityService.getAnimationMode());
};

const handleMouseEnterAnim = async (event, element) => {
  const gotClicked = element.id;
  const gotClickedElement = document.getElementById(gotClicked);
  if (gotClicked === (await identityService.getAnimationMode())) {
    return;
  }
  gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
};

const handleMouseLeaveAnim = async (event, element) => {
  const gotClicked = element.id;
  const gotClickedElement = document.getElementById(gotClicked);
  if (gotClicked === (await identityService.getAnimationMode())) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }
  gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
};

const deslectAllAnim = () => {
  document.getElementById("serial").style.background = "none";
  document.getElementById("parallel").style.background = "none";
  document.getElementById("offAnim").style.background = "none";
};

const selectOneAnim = (whichOne) => {
  deslectAllAnim();
  if (whichOne === "off") {
    whichOne = "offAnim";
  }
  const element = document.getElementById(whichOne);
  element.style.background = colors.getGameColor("accent");
};

const handleAnimationChange = async (event, element) => {
  let gotClicked = element.id;
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  if (gotClicked === "offAnim") {
    gotClicked = "off";
  }
  dasModal.render("<div class=max>Submitting...</div>");
  const result = await identityService.setAnimationMode(gotClicked);
  setTimeout(() => {
    dasModal.close();
  }, 500);
  document.body.style.cursor = "default";
  if (result.status === 200) {
    selectOneAnim(gotClicked);
  } else {
    console.log("ERROR: Unable to change animation mode");
  }
};

////////////////////////////
// Color Settings Functions:

const setColorBarBkgnds = () => {
  document.getElementById("mutedPlayer1color").style.backgroundColor =
    colors.mutedColors.player.playerOne.piece;
  document.getElementById("mutedPlayer2color").style.backgroundColor =
    colors.mutedColors.player.playerTwo.piece;
  document.getElementById("mutedBkgndColor").style.backgroundColor =
    colors.mutedColors.game.background;
  document.getElementById("desertPlayer1color").style.backgroundColor =
    colors.desertColors.player.playerOne.piece;
  document.getElementById("desertPlayer2color").style.backgroundColor =
    colors.desertColors.player.playerTwo.piece;
  document.getElementById("desertBkgndColor").style.backgroundColor =
    colors.desertColors.game.background;
  document.getElementById("darkPlayer1color").style.backgroundColor =
    colors.darkColors.player.playerOne.piece;
  document.getElementById("darkPlayer2color").style.backgroundColor =
    colors.darkColors.player.playerTwo.piece;
  document.getElementById("darkBkgndColor").style.backgroundColor =
    colors.darkColors.game.background;
  document.getElementById("jennPlayer1color").style.backgroundColor =
    colors.jennColors.player.playerOne.piece;
  document.getElementById("jennPlayer2color").style.backgroundColor =
    colors.jennColors.player.playerTwo.piece;
  document.getElementById("jennBkgndColor").style.backgroundColor =
    colors.jennColors.game.background;
};

const handleMouseEnterColor = (event) => {
  const gotEntered = event.target.id;
  if (gotEntered.includes("Bkgnd") || gotEntered.includes("Player")) {
    // these are actual color bar elements, don't change these
    return;
  }

  const scheme = calculateScheme(gotEntered);
  if (scheme === colors.getScheme()) {
    return; // hovering over the selected option, so no change
  }
  event.target.style.backgroundColor = colors.getGameColor("iPop");
};

const handleMouseLeaveColor = (event) => {
  const gotLeft = event.target.id;
  if (gotLeft.includes("Bkgnd") || gotLeft.includes("Player")) {
    // these are actual color bar elements, don't change these
    return;
  }
  const scheme = calculateScheme(gotLeft);
  if (scheme === colors.getScheme()) {
    event.target.style.backgroundColor = colors.getGameColor("accent");
    return;
  }
  event.target.style.backgroundColor = colors.getGameColor("tip");
};

const calculateScheme = (targetId) => {
  let scheme;
  switch (true) {
    case targetId.includes("muted"):
      scheme = "muted";
      break;
    case targetId.includes("desert"):
      scheme = "desert";
      break;
    case targetId.includes("dark"):
      scheme = "dark";
      break;
    case targetId.includes("jenn"):
      scheme = "jenn";
      break;
    default:
      scheme = "unkown";
      break;
  }
  return scheme;
};

const handleColorChange = async (event) => {
  const gotClicked = event.target.id;
  const scheme = calculateScheme(gotClicked);
  if (scheme === "unknown") {
    return; //something else got clicked
  }
  if (scheme === colors.getScheme()) {
    return; //no change
  }
  document.body.style.cursor = "wait";
  dasModal.render("<div class=max>Submitting...</div>");
  const result = await identityService.setScheme(scheme); // save it in the playing as identity
  setTimeout(() => {
    dasModal.close();
  }, 500);
  document.body.style.cursor = "default";
  if (result.status != 200) {
    console.log("Error: API was unable to update the color scheme");
    return;
  }
  if (result.status === 200) {
    colors.setScheme(scheme); //update the UI
  }
  render(); // re-draw settings pop
};

/// pop ups

const handleMouseEnterPop = async (event, element) => {
  const gotClicked = element.id;
  const gotClickedElement = document.getElementById(gotClicked);

  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;

  if (gotClicked === "postLogInOn" && pAIdentity.postLogPop === true) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "postLogInOn" && pAIdentity.postLogPop === false) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (gotClicked === "postLogInOff" && pAIdentity.postLogPop === true) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (gotClicked === "postLogInOff" && pAIdentity.postLogPop === false) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedWatcherOn" &&
    (pAIdentity?.joinedWatcherPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedWatcherOn" &&
    !(pAIdentity?.joinedWatcherPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (
    gotClicked === "joinedWatcherOff" &&
    (pAIdentity?.joinedWatcherPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (
    gotClicked === "joinedWatcherOff" &&
    !(pAIdentity?.joinedWatcherPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedPlayerOn" &&
    (pAIdentity?.joinedPlayerPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedPlayerOn" &&
    !(pAIdentity?.joinedPlayerPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (
    gotClicked === "joinedPlayerOff" &&
    (pAIdentity?.joinedPlayerPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (
    gotClicked === "joinedPlayerOff" &&
    !(pAIdentity?.joinedPlayerPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "createdPopOn" && (pAIdentity?.createdPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "createdPopOn" && !(pAIdentity?.createdPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (gotClicked === "createdPopOff" && (pAIdentity?.createdPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (gotClicked === "createdPopOff" && !(pAIdentity?.createdPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "changedPopOn" && (pAIdentity?.changedPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "changedPopOn" && !(pAIdentity?.changedPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (gotClicked === "changedPopOff" && (pAIdentity?.changedPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("iPop");
    return;
  }

  if (gotClicked === "changedPopOff" && !(pAIdentity?.changedPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }
};

const handleMouseLeavePop = async (event, element) => {
  const gotClicked = element.id;
  const gotClickedElement = document.getElementById(gotClicked);

  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;

  if (gotClicked === "postLogInOn" && pAIdentity.postLogPop === true) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "postLogInOn" && pAIdentity.postLogPop === false) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (gotClicked === "postLogInOff" && pAIdentity.postLogPop === true) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (gotClicked === "postLogInOff" && pAIdentity.postLogPop === false) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedWatcherOn" &&
    (pAIdentity?.joinedWatcherPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedWatcherOn" &&
    !(pAIdentity?.joinedWatcherPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (
    gotClicked === "joinedWatcherOff" &&
    (pAIdentity?.joinedWatcherPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (
    gotClicked === "joinedWatcherOff" &&
    !(pAIdentity?.joinedWatcherPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedPlayerOn" &&
    (pAIdentity?.joinedPlayerPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (
    gotClicked === "joinedPlayerOn" &&
    !(pAIdentity?.joinedPlayerPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (
    gotClicked === "joinedPlayerOff" &&
    (pAIdentity?.joinedPlayerPop ?? true)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (
    gotClicked === "joinedPlayerOff" &&
    !(pAIdentity?.joinedPlayerPop ?? false)
  ) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "createdPopOn" && (pAIdentity?.createdPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "createdPopOn" && !(pAIdentity?.createdPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (gotClicked === "createdPopOff" && (pAIdentity?.createdPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (gotClicked === "createdPopOff" && !(pAIdentity?.createdPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "changedPopOn" && (pAIdentity?.changedPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }

  if (gotClicked === "changedPopOn" && !(pAIdentity?.changedPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (gotClicked === "changedPopOff" && (pAIdentity?.changedPop ?? true)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("tip");
    return;
  }

  if (gotClicked === "changedPopOff" && !(pAIdentity?.changedPop ?? false)) {
    gotClickedElement.style.backgroundColor = colors.getGameColor("accent");
    return;
  }
};

const selectColorOption = (scheme) => {
  document.getElementById(scheme).style.backgroundColor =
    colors.getGameColor("accent");
};

// this is getting messy and redundant.
// need to refactor. But not today.
const setPopOptions = async () => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;
  const postLogInOn = document.getElementById("postLogInOn");
  const postLogInOff = document.getElementById("postLogInOff");
  if (pAIdentity.postLogPop === true) {
    postLogInOn.style.background = colors.getGameColor("accent");
    postLogInOff.style.background = colors.getGameColor("tip");
  }
  if (pAIdentity.postLogPop === false) {
    postLogInOn.style.background = colors.getGameColor("tip");
    postLogInOff.style.background = colors.getGameColor("accent");
  }

  if (Object.keys(pAIdentity).includes("joinedWatcherPop")) {
    const joinedWatcherOn = document.getElementById("joinedWatcherOn");
    const joinedWatcherOff = document.getElementById("joinedWatcherOff");
    if (pAIdentity.joinedWatcherPop === true) {
      joinedWatcherOn.style.background = colors.getGameColor("accent");
      joinedWatcherOff.style.background = colors.getGameColor("tip");
    }
    if (pAIdentity.joinedWatcherPop === false) {
      joinedWatcherOn.style.background = colors.getGameColor("tip");
      joinedWatcherOff.style.background = colors.getGameColor("accent");
    }
  } else {
    // missing attribute means it's on
    const joinedWatcherOn = document.getElementById("joinedWatcherOn");
    const joinedWatcherOff = document.getElementById("joinedWatcherOff");
    joinedWatcherOn.style.background = colors.getGameColor("accent");
    joinedWatcherOff.style.background = colors.getGameColor("tip");
  }

  if (Object.keys(pAIdentity).includes("joinedPlayerPop")) {
    const joinedPlayerOn = document.getElementById("joinedPlayerOn");
    const joinedPlayerOff = document.getElementById("joinedPlayerOff");
    if (pAIdentity.joinedPlayerPop === true) {
      joinedPlayerOn.style.background = colors.getGameColor("accent");
      joinedPlayerOff.style.background = colors.getGameColor("tip");
    }
    if (pAIdentity.joinedPlayerPop === false) {
      joinedPlayerOn.style.background = colors.getGameColor("tip");
      joinedPlayerOff.style.background = colors.getGameColor("accent");
    }
  } else {
    // missing attribute means it's on
    const joinedPlayerOn = document.getElementById("joinedPlayerOn");
    const joinedPlayerOff = document.getElementById("joinedPlayerOff");
    joinedPlayerOn.style.background = colors.getGameColor("accent");
    joinedPlayerOff.style.background = colors.getGameColor("tip");
  }

  if (Object.keys(pAIdentity).includes("createdPop")) {
    const createdPopOn = document.getElementById("createdPopOn");
    const createdPopOff = document.getElementById("createdPopOff");
    if (pAIdentity.createdPop === true) {
      createdPopOn.style.background = colors.getGameColor("accent");
      createdPopOff.style.background = colors.getGameColor("tip");
    }
    if (pAIdentity.createdPop === false) {
      createdPopOn.style.background = colors.getGameColor("tip");
      createdPopOff.style.background = colors.getGameColor("accent");
    }
  } else {
    // missing attribute means it's on
    const createdPopOn = document.getElementById("createdPopOn");
    const createdPopOff = document.getElementById("createdPopOff");
    createdPopOn.style.background = colors.getGameColor("accent");
    createdPopOff.style.background = colors.getGameColor("tip");
  }

  if (Object.keys(pAIdentity).includes("changedPop")) {
    const changedPopOn = document.getElementById("changedPopOn");
    const changedPopOff = document.getElementById("changedPopOff");
    if (pAIdentity.changedPop === true) {
      changedPopOn.style.background = colors.getGameColor("accent");
      changedPopOff.style.background = colors.getGameColor("tip");
    }
    if (pAIdentity.changedPop === false) {
      changedPopOn.style.background = colors.getGameColor("tip");
      changedPopOff.style.background = colors.getGameColor("accent");
    }
  } else {
    // missing attribute means it's on
    const changedPopOn = document.getElementById("changedPopOn");
    const changedPopOff = document.getElementById("changedPopOff");
    changedPopOn.style.background = colors.getGameColor("accent");
    changedPopOff.style.background = colors.getGameColor("tip");
  }
};

const handlePostLogPopChange = async (event, element) => {
  const gotClicked = element.id;
  if (gotClicked === "postLogInOn") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setPostLogPop(true);
    setTimeout(() => {
      dasModal.close();
    }, 500);
    document.body.style.cursor = "default";
  }
  if (gotClicked === "postLogInOff") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setPostLogPop(false);
    setTimeout(() => {
      dasModal.close();
    }, 500);
    document.body.style.cursor = "default";
  }
  render(); // re-draw settings pop
};

const handleJoinedWatcherChange = async (event, element) => {
  const gotClicked = element.id;
  if (gotClicked === "joinedWatcherOn") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setJoinedWatcherPop(true);
    setTimeout(() => {
      dasModal.close();
    }, 500);
    document.body.style.cursor = "default";
  }
  if (gotClicked === "joinedWatcherOff") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setJoinedWatcherPop(false);
    setTimeout(() => {
      dasModal.close();
    }, 500);
    document.body.style.cursor = "default";
  }
  render(); // re-draw settings pop
};

const handleCreatedPopChange = async (event, element) => {
  const gotClicked = element.id;
  if (gotClicked === "createdPopOn") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setCreatedPop(true);
    document.body.style.cursor = "default";
    setTimeout(() => {
      dasModal.close();
    }, 500);
  }
  if (gotClicked === "createdPopOff") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setCreatedPop(false);
    document.body.style.cursor = "default";
    setTimeout(() => {
      dasModal.close();
    }, 500);
  }
  render(); // re-draw settings pop
};

const handleJoinedPlayerChange = async (event, element) => {
  const gotClicked = element.id;
  if (gotClicked === "joinedPlayerOn") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setJoinedPlayerPop(true);
    document.body.style.cursor = "default";
    setTimeout(() => {
      dasModal.close();
    }, 500);
  }
  if (gotClicked === "joinedPlayerOff") {
    dasModal.render("<div class=max>Submitting...</div>");
    document.body.style.cursor = "wait";
    await identityService.setJoinedPlayerPop(false);
    document.body.style.cursor = "default";
    setTimeout(() => {
      dasModal.close();
    }, 500);
  }
  render(); // re-draw settings pop
};

const handleChangedPopChange = async (event, element) => {
  const gotClicked = element.id;
  if (gotClicked === "changedPopOn") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setChangedPop(true);
    document.body.style.cursor = "default";
    setTimeout(() => {
      dasModal.close();
    }, 500);
  }
  if (gotClicked === "changedPopOff") {
    document.body.style.cursor = "wait";
    dasModal.render("<div class=max>Submitting...</div>");
    await identityService.setChangedPop(false);
    document.body.style.cursor = "default";
    setTimeout(() => {
      dasModal.close();
    }, 500);
  }
  render(); // re-draw settings pop
};

eventHub.registerEvent("click", "settingsSection", handleGearClick);
eventHub.registerEvent("click", "modalBehinderClosePrefs", handlecloseClick);
eventHub.registerEvent("click", "closeSettingsPop", handlecloseClick);

//colors
eventHub.registerEvent("click", "muted", handleColorChange);
eventHub.registerEvent("pointerover", "muted", handleMouseEnterColor);
eventHub.registerEvent("pointerout", "muted", handleMouseLeaveColor);

eventHub.registerEvent("click", "desert", handleColorChange);
eventHub.registerEvent("pointerover", "desert", handleMouseEnterColor);
eventHub.registerEvent("pointerout", "desert", handleMouseLeaveColor);

eventHub.registerEvent("click", "dark", handleColorChange);
eventHub.registerEvent("pointerover", "dark", handleMouseEnterColor);
eventHub.registerEvent("pointerout", "dark", handleMouseLeaveColor);

eventHub.registerEvent("click", "jenn", handleColorChange);
eventHub.registerEvent("pointerover", "jenn", handleMouseEnterColor);
eventHub.registerEvent("pointerout", "jenn", handleMouseLeaveColor);

//email prefs
eventHub.registerEvent("click", "accountOn", handleEmailChange);
eventHub.registerEvent("pointerout", "accountOn", handleMouseLeaveEmail);
eventHub.registerEvent("pointerover", "accountOn", handleMouseEnterEmail);

eventHub.registerEvent("click", "accountOff", handleEmailChange);
eventHub.registerEvent("pointerout", "accountOff", handleMouseLeaveEmail);
eventHub.registerEvent("pointerover", "accountOff", handleMouseEnterEmail);

eventHub.registerEvent("click", "matchOn", handleEmailChange);
eventHub.registerEvent("pointerout", "matchOn", handleMouseLeaveEmail);
eventHub.registerEvent("pointerover", "matchOn", handleMouseEnterEmail);

eventHub.registerEvent("click", "matchOff", handleEmailChange);
eventHub.registerEvent("pointerout", "matchOff", handleMouseLeaveEmail);
eventHub.registerEvent("pointerover", "matchOff", handleMouseEnterEmail);

eventHub.registerEvent("click", "marketingOn", handleEmailChange);
eventHub.registerEvent("pointerout", "marketingOn", handleMouseLeaveEmail);
eventHub.registerEvent("pointerover", "marketingOn", handleMouseEnterEmail);

eventHub.registerEvent("click", "marketingOff", handleEmailChange);
eventHub.registerEvent("pointerout", "marketingOff", handleMouseLeaveEmail);
eventHub.registerEvent("pointerover", "marketingOff", handleMouseEnterEmail);

//animation mode
eventHub.registerEvent("click", "serial", handleAnimationChange);
eventHub.registerEvent("pointerout", "serial", handleMouseLeaveAnim);
eventHub.registerEvent("pointerover", "serial", handleMouseEnterAnim);

eventHub.registerEvent("click", "parallel", handleAnimationChange);
eventHub.registerEvent("pointerout", "parallel", handleMouseLeaveAnim);
eventHub.registerEvent("pointerover", "parallel", handleMouseEnterAnim);

eventHub.registerEvent("click", "offAnim", handleAnimationChange);
eventHub.registerEvent("pointerout", "offAnim", handleMouseLeaveAnim);
eventHub.registerEvent("pointerover", "offAnim", handleMouseEnterAnim);

eventHub.registerEvent("click", "postLogInOn", handlePostLogPopChange);
eventHub.registerEvent("pointerover", "postLogInOn", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "postLogInOn", handleMouseLeavePop);

eventHub.registerEvent("click", "postLogInOff", handlePostLogPopChange);
eventHub.registerEvent("pointerover", "postLogInOff", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "postLogInOff", handleMouseLeavePop);

eventHub.registerEvent("click", "joinedWatcherOn", handleJoinedWatcherChange);
eventHub.registerEvent("pointerover", "joinedWatcherOn", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "joinedWatcherOn", handleMouseLeavePop);

eventHub.registerEvent("click", "joinedWatcherOff", handleJoinedWatcherChange);
eventHub.registerEvent("pointerover", "joinedWatcherOff", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "joinedWatcherOff", handleMouseLeavePop);

eventHub.registerEvent("click", "joinedPlayerOn", handleJoinedPlayerChange);
eventHub.registerEvent("pointerover", "joinedPlayerOn", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "joinedPlayerOn", handleMouseLeavePop);

eventHub.registerEvent("click", "joinedPlayerOff", handleJoinedPlayerChange);
eventHub.registerEvent("pointerover", "joinedPlayerOff", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "joinedPlayerOff", handleMouseLeavePop);

eventHub.registerEvent("click", "createdPopOn", handleCreatedPopChange);
eventHub.registerEvent("pointerover", "createdPopOn", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "createdPopOn", handleMouseLeavePop);

eventHub.registerEvent("click", "createdPopOff", handleCreatedPopChange);
eventHub.registerEvent("pointerover", "createdPopOff", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "createdPopOff", handleMouseLeavePop);

eventHub.registerEvent("click", "changedPopOn", handleChangedPopChange);
eventHub.registerEvent("pointerover", "changedPopOn", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "changedPopOn", handleMouseLeavePop);

eventHub.registerEvent("click", "changedPopOff", handleChangedPopChange);
eventHub.registerEvent("pointerover", "changedPopOff", handleMouseEnterPop);
eventHub.registerEvent("pointerout", "changedPopOff", handleMouseLeavePop);

eventHub.registerEvent("click", "createdPopSplainer", renderCreatedPopSplainer);
eventHub.registerEvent("click", "joinedSplainer", renderJoinedSplainer);
eventHub.registerEvent("click", "changedPopSplainer", renderChangedPopSplainer);
eventHub.registerEvent("click", "newWatcherSplainer", renderNewWatcherSplainer);

eventHub.registerEvent("click", "marketingSplainer", renderMarketingSplainer);

export const preferences = {
  renderGear,
  close,
  isVisible,
};
